import {useRef, useMemo} from 'react'
import {useSelectContext} from '~/components/select/context'

const ITEM_HEIGHT = 40
const MAX_CONTAINER_HEIGHT = 500

export const useSelectItemsContainerStyle = () => {
	const containerRef = useRef(null)
	const {expandedGroups, virtualized, items, itemHeight = ITEM_HEIGHT} = useSelectContext()

	const visibleItemCount = useMemo(() => {
		return items.reduce((acc, item) => {
			if (item.type === 'nested-item') return acc
			if (item.group && !expandedGroups.has(item.group)) return acc
			return acc + 1
		}, 0)
	}, [items, expandedGroups])

	const style = useMemo(() => {
		if (!virtualized || visibleItemCount === 0) return {}

		const contentHeight = visibleItemCount * itemHeight

		// Keep height independent from rendered layout measurements to avoid browser zoom rounding feedback loops.
		return {height: Math.min(contentHeight, MAX_CONTAINER_HEIGHT)}
	}, [virtualized, visibleItemCount, itemHeight])

	return {containerRef, style}
}
